export const kmKH: { [k: string]: string } = {
  // DO NOT REMOVE THIS COMMENT
  
}
